<template>
  <div class="basicssetup">
    <div class="header">
      <div style="display:flex;align-items: center;">
        <img src="@/assets/house/breadicon.png"
             style="margin-right:10px"
             alt="">
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item>工作桌面</el-breadcrumb-item> -->
          <el-breadcrumb-item>系统设置</el-breadcrumb-item>
          <el-breadcrumb-item>单点登录配置</el-breadcrumb-item>
          <!-- <el-breadcrumb-item>活动详情</el-breadcrumb-item> -->
        </el-breadcrumb>
      </div>
      <div @click="refresh"
           class="refresh">
        <img :class="isRefresh ?'imgmove':''"
             width="16px"
             height="16px"
             src="@/assets/house/refresh.png"
             alt />
        <p>刷新</p>
      </div>
    </div>

    <div v-loading="isRefresh">
      <div class="main">
        <h4>单点登录配置</h4>
        <div class="upbg">
          <el-form :model="ruleForm"
                   :rules="rules"
                   ref="ruleFormPT"
                   label-width="100px"
                   class="demo-ruleForm">
            <el-row>
              <el-col :span="24"
                      style="margin-right:10px;">
                <el-form-item label="单点登录开关:"
                              prop="ssoMode">
                  <el-radio-group v-model="ruleForm.ssoMode"
                                  :fill="isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'"
                                  size="medium">
                    <el-radio-button label="on">开启</el-radio-button>
                    <el-radio-button label="off">关闭</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row v-if="ruleForm.ssoMode == 'on' ">
              <el-col :span="24"
                      style="margin-right:10px;margin-bottom:30px;">

                <el-form-item label="单点登录配置:"
                              prop="ssoConfig">
                    <el-input v-model="ruleForm.ssoConfig "
                      style="width:100%;height:560px;"
                      placeholder="配置JSON，不超过5000字"
                              type="textarea"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

          </el-form>


          <!-- <div class="main"
              style="padding-top:0px;"
              v-if="ruleForm.sensitiveWordsMode !== 'off'">
            <p>敏感词清单</p>
            <div class="upbg"
                style="padding:0px;height:300px;">
              <el-input v-model="ruleForm.sensitiveWords"
                        style="width:100%;height:100%;"
                        placeholder="请填写敏感词清单"
                                type="textarea"></el-input>
            </div>
          </div> -->
        </div>
      </div>

      

      <!-- <div class="main"
           style="padding-top:0px;"
           v-if="ruleForm.sensitiveWordsMode !== 'off'">
        <h4>敏感词清单</h4>
        <div class="upbg"
             style="padding:0px;height:300px;">
          <el-input v-model="ruleForm.sensitiveWords"
                    style="width:100%;height:100%;"
                    placeholder="请填写敏感词清单"
                            type="textarea"></el-input>
        </div>
      </div> -->

    </div>

    <div class="bottombtn">
      <div class="btn">
        <!-- <el-button :disabled="isRefresh" @click="closeForm">取消</el-button> -->
        <el-button :disabled="isRefresh"
                   @click="submitForm('ruleForm')"
                   :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                   type="primary">提交</el-button>
      </div>
    </div>

  </div>
</template>

<script>

import { picPrefix } from "@/constants/piccommon";
import { setSsoConfig, getSsoConfig } from "@/api/config";
export default {
  components: {

  },
  data () {
    return {
      picPrefix,

      reg: '',
      auth: '',
      ruleFormPTFlag: false,
      ruleForm: {
        ssoMode: 'off',
        ssoConfig: '',
      },

      rules: {
        ssoConfig: [
          { min: 0, max: 5000, message: '长度在 5000 个字符以内', trigger: 'blur' }
        ],
      },

      //网站徽标
      logoFile: null,


      isRefresh: false
    };
  },
  methods: {


    //刷新表格
    refresh () {

      this.isRefresh = true
      this.getSsoConfigAsync();
      setTimeout(() => {
        this.isRefresh = false
      }, 888);
    },


    closeForm () {
      this.$message('正在开发中……')
    },

    importSensitive(){
      this.$message('正在开发中……')
    },




    submitForm () {
      // console.log(this.phoneEditorReg.txt.html())
      if(this.ruleForm.ssoMode !== 'off'){
        if (
          this.ruleForm.ssoMode &&
          this.ruleForm.ssoConfig 
        ) {
          let data = {
            ssoMode: this.ruleForm.ssoMode,
            ssoConfig: this.ruleForm.ssoConfig
          }
          this.setSsoConfigAsync(data)
        } else {
          this.$message.error('请全部填写！')
        }
      }else{
        let data = {
          ssoMode: this.ruleForm.ssoMode,
          ssoConfig: ''
        }
        this.setSsoConfigAsync(data)
      }
      




    },





    //获取配置
    async getSsoConfigAsync () {
      this.isRefresh = true
      let { status, data, message, errors } = await getSsoConfig();
      if (status) {
        if (data.ssoConfig) {
          this.ruleForm.ssoConfig = data.ssoConfig
        }
        if (data.ssoMode) {
          this.ruleForm.ssoMode = data.ssoMode
        }


        this.isRefresh = false
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
        this.isRefresh = false
      }
    },
    //设置配置
    async setSsoConfigAsync (val) {
      let { status, data, message, errors } = await setSsoConfig(val);
      if (status) {
        this.$message.success('设置成功！');
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

  },
  created () {
    this.getSsoConfigAsync()
  },
  mounted () {
    
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./oneloginmanage.scss";

h4 {
  font-size: 18px;
}
.basicssetup{
  position: relative;
}
.bottombtn {
  min-width: calc(100vw - 62px);
  // width: 100%;
  height: 80px;
  background: #fff;
  box-shadow: 0 -2px 6px -2px rgba(0, 0, 0, 0.2);
  border-top: 1px solid #e1e1e1;
  display: flex;
  align-items: center;
  position: fixed;
  bottom: 0px;
  right: 2px;
  // top: 0;
  z-index: 5;
  .btn {
    margin-left: auto;
    margin-right: 45px;
  }
}

.bottombtn /deep/ .el-button {
  width: 100px;
  height: 40px;
  font-size: 14px;
}
.bottombtn /deep/ .el-button--primary {
  background-color: #185ED3;
}
/deep/ .el-form-item__label {
  font-weight: 600;
}

/deep/ .el-loading-mask {
  z-index: 2;
}
/deep/ .el-icon-circle-close {
  margin-top: 150px;
}

.el-form /deep/ textarea::-webkit-scrollbar {
    width: 8px;
    height: 32px;
  }
.el-form /deep/ textarea::-webkit-scrollbar-thumb {
    border-radius: 3px;
    height: 38px;
    /* 滚动条滑块长度 */
    background: rgba(24, 94, 212, 0.2);
  }
</style>
